import React from 'react'
import { DataGridActionCell } from '@the-platform-group/component-library/DataGrid'
import { SyncAlt as SyncAltIcon } from '@the-platform-group/component-library/Icons'
import { useConfirmationDialog } from 'components/ConfirmationDialog'
import USER_SCOPES, { getNextScope } from 'constants/userScopes'

const ScopeChangeAction = ({ name, scope, authorizationId, mutation }) => {
  const { createConfirmationDialog } = useConfirmationDialog()
  const newScope = getNextScope(scope)

  return (
    <DataGridActionCell
      icon={<SyncAltIcon />}
      title={scope === USER_SCOPES.user ? 'Make Assistant' : 'Make User'}
      onClick={() => {
        createConfirmationDialog({
          title: `Change ${name}'s scope to ${newScope}?`,
          onConfirm: () => mutation.mutate({ id: authorizationId, scope: newScope }),
        })
      }}
    />
  )
}

export default ScopeChangeAction
